/**
 * Legacy redirect: /admin/reports/gst → /admin/gst.
 * @file src/web/features/admin/pages/reports/gst.tsx
 *
 * GST moved out of Reports into its own top-level section. Kept as a redirect
 * so old links/bookmarks still land in the right place.
 */

import { Navigate } from 'react-router-dom';

export default function GstMovedRedirect() {
  return <Navigate to="/admin/gst" replace />;
}
